export { default as GenericNodeComponent } from './GenericNodeComponent';
